import { TextField, Typography } from '@mui/material'
import Grid from '@mui/material/Grid'

import CreditCardCvv from './components/CreditCardCvv'
import CreditCardDate from './components/CreditCardDate'
import CreditCardNumber from './components/CreditCardNumber'

export default function CreditCard(): JSX.Element {
  return (
    <Grid className="credit-wrap" container rowGap={3} flexDirection="column">
      <TextField className="credit-name" label="Name On Card" name="credit-card-name" fullWidth />
      <CreditCardNumber />
      <Grid className="credit-inner-wrap" container spacing={2}>
        <Grid xs={8} md={9} item>
          <CreditCardDate />
        </Grid>
        <Grid xs={4} md={3} item>
          <CreditCardCvv />
        </Grid>
      </Grid>
      <Typography
        sx={{
          color: '#595959',
          textAlign: 'center',
          fontSize: '12px',
        }}
      >
        Debit charges will occur within 30 minutes
      </Typography>
    </Grid>
  )
}
